export default __webpack_public_path__ + "static/media/logo-qlh.32634ff0.svg";